<mat-card-actions align="end">
  <button mat-button type="button" (click)="close()">Fermer</button>
</mat-card-actions>

<div style="overflow-y: scroll; max-height: 750px;">
  <app-historic-list *ngIf="avis" [avis]="avis"></app-historic-list>
</div>
